// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let AgentMarketingProfilePhotoForm = require("./AgentMarketingProfilePhotoForm.bs.js");
let AgentMarketingProfileFeaturedPortraitForm = require("./AgentMarketingProfileFeaturedPortraitForm.bs.js");
let AgentMarketingProfilePhotosSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfilePhotosSettingsQuery_graphql.bs.js");

function AgentMarketingProfilePhotosSettings$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  let breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Photos"),
      href: MarketingProfileSubpages.Page.Agent.path("Photos")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("Photos"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3"
  });
}

let Header = {
  make: AgentMarketingProfilePhotosSettings$Header
};

let convertVariables = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, AgentMarketingProfilePhotosSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(AgentMarketingProfilePhotosSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfilePhotosSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AgentMarketingProfilePhotosSettings$Header, {}),
              className: "pb-2"
            }),
            JsxRuntime.jsx(AgentMarketingProfilePhotoForm.make, {
              marketingProfile: marketingProfile.fragmentRefs
            }),
            ReactRender.ifTrue(JsxRuntime.jsx(AgentMarketingProfileFeaturedPortraitForm.make, {
              marketingProfile: marketingProfile.fragmentRefs
            }), hasFullProfile)
          ],
          className: "space-y-8 sm:space-y-0 divide-y divide-zinc-200"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            href: Scalars.URL.toString(marketingProfile.publicUrl),
            target: "_blank",
            children: "View Profile"
          }),
          className: "flex justify-between border-t border-zinc-200 pt-4"
        })
      ],
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = AgentMarketingProfilePhotosSettings;

exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
